import '.d{display:flex;}.ssr-plugin'
import '.b0{max-width:77.5rem;}.ssr-plugin'
import '.bg{padding-top:4rem;}.ssr-plugin'
import '.bh{padding-bottom:10rem;}.ssr-plugin'
import '.bi{justify-content:space-between;}.ssr-plugin'
import '.bj{row-gap:2rem;}.ssr-plugin'
import '.al{align-items:flex-start;}.ssr-plugin'
import '.bk{flex-wrap:wrap;}.ssr-plugin'
import '.aj{border-radius:1.25rem;}.ssr-plugin'
import '.bl{background-color:var(--brand-accent);}.ssr-plugin'
import '.bm{background-repeat:no-repeat;}.ssr-plugin'
import '.bn{background-position-y:100%;}.ssr-plugin'
import '.bo{cursor:default;}.ssr-plugin'
import '.bp{gap:0.62rem;}.ssr-plugin'
import { styled } from 'inlines'
import footerBackground from '@app/assets/footerBackground.svg'
import fullLogo from '@app/assets/fullLogo.svg'
import { Text } from '@app/components/core/typography/Text'
import { useTranslations } from '@i18n/useLanguage'
import Column from '@app/components/layout/Column'
import { Title } from '@app/components/core/typography/Title'
import { TextLink, TextLinkProps } from '@app/components/core/link/TextLink'
import { Facebook, Instagram, LinkedIn } from './SocialIcons'
import { pages, social } from '@app/util/links'
import useMediaQuery from '@app/util/useMediaQuery'
import { memo, useEffect, useState } from 'react'
import { CollapsibleSection } from '../collapsibleSection/CollapsibleSection'
import { Image } from '@app/components/core/image/Image'
import { ResponsiveContainer } from '@app/components/layout/ResponsiveContainer'

const FooterLink = (props: TextLinkProps) => {
  return (
    <TextLink
      {...props}
      size="small"
      textStyle={{ lineHeight: '100%', ...props.textStyle }}
      containerStyle={{ ...props.containerStyle, textDecoration: 'none' }}
    />
  )
}

const Footer = () => {
  const isMobile = useMediaQuery()
  const translations = useTranslations().app
  const [mounted, setMounted] = useState(false)
  const columnStyle = {
    minWidth: '10rem',
  }

  useEffect(() => {
    setMounted(true)
  }, [])

  return (
    <ResponsiveContainer>
      <footer className="d b0 bg bh bi bj al bk aj bl bm bn bo"
        style={{
          flexDirection: isMobile ? 'column' : 'row',
          minHeight: isMobile ? 0 : '45rem',
          paddingInline: isMobile ? '2rem' : '4rem',
          backgroundImage: mounted ? `url("${footerBackground}")` : undefined,
          backgroundSize: isMobile ? '100% 5rem' : '100% 20rem',}}
      >
        <Column gap="1rem" style={{ ...columnStyle, minWidth: '15rem' }}>
          <Image src={fullLogo} style={{ padding: '0.375rem 0' }} />
          <Text.Subtitle
            isBold={true}
            style={{ whiteSpace: isMobile ? 'normal' : 'pre-wrap' }}
          >
            {translations.footer.slogan}
          </Text.Subtitle>
        </Column>
        <Section title={translations.footer.info}>
          <Column>
            <FooterLink
              to={`${pages.knowledgeHubModule('je-account-project')}?slug=account-maken`}
            >
              {translations.footer.sections.info.howDoesItWork}
            </FooterLink>
            <FooterLink to={pages.contactUs}>
              {translations.footer.sections.info.contactUsLink}
            </FooterLink>
            <FooterLink to={pages.knowledgeHub}>
              {translations.footer.sections.info.knowledgeHub}
            </FooterLink>
            <FooterLink to={pages.blogs('verhalen')}>
              {translations.footer.sections.info.storiesLink}
            </FooterLink>
            <FooterLink to={pages.blogs()}>
              {translations.footer.sections.info.blogAndNewsLink}
            </FooterLink>
            <FooterLink to={social.luma} target="_blank">
              {translations.footer.sections.info.events}
            </FooterLink>
            <FooterLink to={pages.legal}>
              {translations.footer.sections.info.termsAndConditions}
            </FooterLink>
            <FooterLink to={pages.legal}>
              {translations.footer.sections.info.privacy}
            </FooterLink>
          </Column>
        </Section>
        <Section title={translations.footer.services}>
          <Column>
            <FooterLink to={pages.initiatives}>
              {translations.footer.sections.services.initiatives}
            </FooterLink>
            <FooterLink to={pages.plots}>
              {translations.footer.sections.services.plots}
            </FooterLink>
            <FooterLink to={pages.housingForms}>
              {translations.footer.sections.services.housingForms}
            </FooterLink>
            <FooterLink to={pages.serviceProviders}>
              {translations.footer.sections.services.experts}
            </FooterLink>
            <FooterLink to={pages.rabobankLanding}>
              {translations.footer.sections.services.cpoDesks}
            </FooterLink>
          </Column>
        </Section>
        <Column gap="3.5rem" style={columnStyle}>
          <Section title={translations.footer.joinIn}>
            <Column>
              <FooterLink to={pages.initiatives}>
                {translations.footer.sections.joinIn.joinGroup}
              </FooterLink>
              <FooterLink to={pages.plots}>
                {translations.footer.sections.joinIn.applyForPlot}
              </FooterLink>
              <FooterLink to={pages.forExperts}>
                {translations.footer.sections.joinIn.forExperts}
              </FooterLink>
              <FooterLink to={pages.forMunicipalities}>
                {translations.footer.sections.joinIn.forMunicipalities}
              </FooterLink>
              {/* <FooterLink to={externalPages.jobs} target="_blank">
                {translations.footer.sections.joinIn.joinUsLink}
              </FooterLink> */}
            </Column>
          </Section>
          <Column>
            <div className="d bp">
              <FooterLink to={social.facebook} noHover={true} target="_blank">
                <Facebook />
              </FooterLink>
              <FooterLink to={social.instagram} noHover={true} target="_blank">
                <Instagram />
              </FooterLink>
              <FooterLink to={social.linkedin} noHover={true} target="_blank">
                <LinkedIn />
              </FooterLink>
            </div>
            <Text.ExtraSmall style={{ fontWeight: 300 }}>
              Copyright © {new Date().getFullYear()} CrowdBuilding.
            </Text.ExtraSmall>
          </Column>
        </Column>
      </footer>
    </ResponsiveContainer>
  )
}

const Section = ({
  title,
  children,
}: {
  title: string
  children: React.ReactNode
}) => {
  const columnStyle = {
    minWidth: '10rem',
  }
  const isMobile = useMediaQuery()
  if (isMobile) {
    return (
      <Column gap="1.5rem" style={columnStyle}>
        <CollapsibleSection
          title={<Title.H5 style={{ margin: 0 }}>{title}</Title.H5>}
        >
          {children}
        </CollapsibleSection>
      </Column>
    )
  }

  return (
    <Column gap="1.5rem" style={columnStyle}>
      <Title.H4 style={{ margin: 0 }}>{title}</Title.H4>
      {children}
    </Column>
  )
}

export default memo(Footer)
